import React from 'react';
import {
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardTitle,
  CCardText,
  CBadge,
  CImage,
} from '@coreui/react';
import { useState } from 'react';
import resolveImage from '../../store/ResolveImage';
import { API_URL } from '../../../constants';
import { useNavigate, Link } from 'react-router-dom';
import { formatDate } from '../../../utils/formatDate';
import { withRouter } from '../../../withRouter';
import actions from '../../../actions';
import { connect } from 'react-redux';
import Button from '../../Common/HtmlTags/Button';
import ManagerPagination from '../Pagination';
import LoadingIndicator from '../../store/LoadingIndicator';
import Input from '../../Common/HtmlTags/Input';

const ManagerOrderList = (props) => {
  const { isLightMode, orderIsLoading, orderGroups = [] } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const groupsPerPage = 10;
  const filteredGroups = orderGroups.filter(group =>
    (group.eventName || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredGroups.length / groupsPerPage);
  const startIndex = (currentPage - 1) * groupsPerPage;
  const endIndex = startIndex + groupsPerPage;
  const currentGroups = filteredGroups.slice(startIndex, endIndex);
  const navigate = useNavigate();
  const totalOrders = orderGroups.reduce((sum, group) => sum + (group.orderCount || 0), 0);

  const handleSearch = (name, value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };

  return (
    <div data-aos="fade-up" className='container-lg px-4 d-flex flex-column mb-custom-5em'>
      {orderIsLoading && <LoadingIndicator />}
        <div className='d-flex justify-content-between'>
        <h2 style={{ margin: 0 }} className={`${isLightMode ? 'p-black': 'p-white'}`}>Orders</h2>
        {
          <Button onClick={() => navigate("/dashboard/orders/my-orders")} cls={`${isLightMode ? 'bg-white p-black': 'bg-black p-white'} align-self-end`} type={"third-btn"} text={"My orders"}/>
        }
        </div>
        <hr className={`${isLightMode ? 'p-black': 'p-white'}`} style={{ margin: '.5em' }}></hr>
        <h2 className={`${isLightMode ? 'p-black': 'p-white'} font-size-20`}>{filteredGroups.length} Events · {totalOrders} Orders</h2>

      <div className="mb-4">
        <Input
          type="search"
          placeholder="Search events by name..."
          name="searchOrderEvents"
          value={searchTerm}
          onInputChange={handleSearch}
        />
      </div>

      <CRow className='gy-4'>
      {currentGroups.map((group) => {
        return (
       <CCol md={6} key={group.eventKey}>
        <Link to={`/dashboard/orders/event/${group.eventKey}`}>
      <CCard style={{ height: '95%' }} className={`${isLightMode ? 'bg-white p-black' : 'bg-black p-white border'} flex-row overflow-hidden`}>
      <div style={{ width: '40%' }}>
        <CImage
          src={resolveImage(group.imageUrl ? API_URL + group.imageUrl : '')}
          alt={group.eventName}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </div>
      <CCardBody>
        <CCardTitle className='mb-2'>
          {group.eventName || 'Deleted event'}
        </CCardTitle>
        <CBadge color={group.eventExists ? (group.status === 'Ended' ? 'danger' : group.status === 'Upcoming' ? 'primary' : group.status === 'Ongoing' ? 'success' : 'secondary') : 'warning'} className='mb-2'>
          {group.eventExists ? (group.status || 'Event') : 'Event removed'}
        </CBadge>
        <CCardText className='mt-2'>
          <strong>Orders:</strong> {group.orderCount}<br />
          {group.location && <><strong>Venue:</strong> {group.location}<br /></>}
          {group.startDate && <><strong>Start Date:</strong> {formatDate(group.startDate)}<br /></>}
          {group.latestOrderAt && <><strong>Latest order:</strong> {formatDate(group.latestOrderAt)}</>}
        </CCardText>
      </CCardBody>
    </CCard>
  </Link>
  </CCol>
)})}
      </CRow>
        <ManagerPagination
          isLightMode={isLightMode}
          data={filteredGroups}
          totalPages={totalPages}
          startIndex={startIndex}
          endIndex={endIndex}
          onPageChange={setCurrentPage}
        />
    </div>
  );
};

class ManagerOrder extends React.PureComponent {
  componentDidMount () {
    this.props.fetchOrders();
  }

  render () {
    return (
      <ManagerOrderList {...this.props} />
    );
  }
}

const mapStateToProps = state => ({
  orderGroups: state.order.orderGroups,
  orderIsLoading: state.order.isLoading
});

export default connect(mapStateToProps, actions)(withRouter(ManagerOrder));
